import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { Layout, Table } from "antd";
import EditDevice from "./EditDevice";
import { GET_DEVICES, DELETE_DEVICES } from "./Requests";
import "../../UI/CommonStyles.less";
import Filters from "./Filters";
import Footer from "../../Components/Footer";
import Actions from "../../Components/Actions";
import Header from "../../Components/Header";
import { useTranslation } from "react-i18next";
import {
  getContentRows,
  getContentColumns,
  checkIfNextDisabled
} from "./Utility/TableUtility";
import DeleteModal from "../../Components/DeleteModal";

const { Content } = Layout;

const Devices = ({ history }) => {
  const { t } = useTranslation();
  const [idClicked, setIdClicked] = useState(undefined);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [page, setPage] = useState(1);
  const [number, setNumber] = useState(20);
  const [company, setCompany] = useState(undefined);
  const [machine, setMachine] = useState("");
  const [user, setUser] = useState(undefined);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [deleteMultipleDevices] = useMutation(DELETE_DEVICES);
  const { data, refetch } = useQuery(GET_DEVICES, {
    variables: {
      number: number,
      page: page,
      company,
      machine: machine,
      user
    },
    fetchPolicy: "network-only"
  });

  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys
  };

  const rowIdClicked = (record) => {
    return {
      onClick: () => {
        setIdClicked(record.id);
      }
    };
  };

  const handleDelete = async () => {
    await deleteMultipleDevices({
      variables: {
        ids: selectedRowKeys
      },
      update: (cache, res) => {}
    }).catch((error) => {
      alert(error);
    });
    refetch();
    setSelectedRowKeys([]);
  };

  const beforeCloseDeleteModal = () => {
    setDeleteModal(false);
    setSelectedRowKeys([]);
  }

  const beforeConfirmDeleteModal = () => {
    setDeleteModal(false);
    setSelectedRowKeys([]);
    handleDelete();
  }

  return (
    <Layout className="pageContainer">
      {idClicked !== undefined && (
        <EditDevice
          refetch={refetch}
          history={history}
          onClose={() => setIdClicked(undefined)}
          id={idClicked}
        />
      )}

      <Header name={t("DEVICES")}>
        <Filters
          setUser={setUser}
          setMachine={setMachine}
          setCompany={setCompany}
        />
      </Header>

      <Content className="">
        <Actions
          disbaleAdd={true}
          deletePicked={() => setDeleteModal(true)}
          disableDelete={!selectedRowKeys.length}
        />
        <Table
          pagination={false}
          rowSelection={rowSelection}
          dataSource={getContentRows(data)}
          columns={getContentColumns(t)}
          onRow={rowIdClicked}
          footer={() => (
            <Footer
              setPage={setPage}
              setNumber={setNumber}
              page={page}
              number={number}
              nextDisable={checkIfNextDisabled(data, number)}
            />
          )}
        />
      </Content>
      <DeleteModal
        show={showDeleteModal}
        onClose={beforeCloseDeleteModal}
        onDelete={beforeConfirmDeleteModal}
      />
    </Layout>
  );
};

export default Devices;
